export const unknownBalanceValue = "- -";
